import { ActivityEntity } from '../api/types/Insights';
import { FC, SVGProps } from 'react';

export enum IspmTopListsItem {
    TopActive = 'TopActive',
    TopDenied = 'TopDenied'
}

export type IspmTopListsItemType = {
    counterColumnTitle: string;
    icon: FC<SVGProps<SVGSVGElement>>;
    id: IspmTopListsItem;
    prefix: string;
    resources: ActivityEntity[];
    title: string;
    users: ActivityEntity[];
};
